<div class="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
    <div class="card shadow-sm p-4 text-center" style="max-width: 500px; width: 100%;">
        <div *ngIf="!isError" class="mb-4">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Cargando...</span>
            </div>
        </div>

        <div *ngIf="isError" class="mb-4 text-danger">
            <i class="bi bi-exclamation-circle-fill" style="font-size: 3rem;"></i>
        </div>

        <h2 class="mb-3" [class.text-danger]="isError" [class.text-primary]="!isError">
            {{ isError ? 'Error de Autenticación' : 'Autenticando' }}
        </h2>

        <p class="lead text-muted mb-4">
            {{ statusMessage }}
        </p>

        <div *ngIf="showCloseSessionsButton" class="mt-3">
            <button class="btn btn-warning w-100" (click)="cerrarTodasLasSesiones()">
                <i class="bi bi-door-closed me-2"></i>Cerrar sesiones previas
            </button>
        </div>
    </div>

    <div class="mt-4 text-muted small">
        <p>Redirigiendo a Clave Única o procesando respuesta...</p>
    </div>
</div>